import React from "react";
import DiscardChangesModal from "app/components/common/DiscardChangesModal";

// Thin wrapper over the shared DiscardChangesModal so the unsaved-changes
// prompt matches the rest of the app. External props are unchanged.
const UnsavedChangesModal = ({ show, onClose, onLeave }) => (
  <DiscardChangesModal show={show} onHide={onClose} onConfirm={onLeave} />
);

export default UnsavedChangesModal;
